import { temAcesso } from '@/bibliotecas/seguranca/authLib'
const FuncionarioPainel = () => import('./painel/FuncionarioPainel.vue')
const FuncionarioAgendamentos = () => import('./agendamentos/Agendamentos.vue')
const FuncionarioSemAcionamentos = () =>
    import('./semacionamentos/SemAcionamentos.vue')
const FuncionarioDevedoresSemAcordo = () =>
    import('./devedores/DevedoresSemAcordo.vue')
const FuncionarioDevedoresComAcordo = () =>
    import('./devedores/DevedoresComAcordo.vue')
const FuncionarioCreditosRecuperados = () =>
    import('./creditosrecuperados/CreditosRecuperados.vue')
const FuncionarioParcelas = () => import('./parcelas/Parcelas.vue')

export default {
    path: 'funcionarios',
    name: 'Funcionarios',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        next()
    },
    children: [
        {
            path: 'painel',
            name: 'Funcionario_Painel',
            component: FuncionarioPainel,
            beforeEnter: (to, from, next) => {
                if (temAcesso('FUNC-PAINEL-00')) {
                    next()
                }
            }
        },
        {
            path: 'agendamentos',
            name: 'Funcionario_Agendamentos',
            component: FuncionarioAgendamentos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('FUNC-AGEND-00')) {
                    next()
                }
            }
        },
        {
            path: 'semacionamentos',
            name: 'Funcionario_SemAcionamentos',
            component: FuncionarioSemAcionamentos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('FUNC-AGEND-00')) {
                    next()
                }
            }
        },
        {
            path: 'creditosrecuperados',
            name: 'Funcionario_CreditosRecuperados',
            component: FuncionarioCreditosRecuperados,
            beforeEnter: (to, from, next) => {
                if (temAcesso('FUNC-CREDRECUP-00')) {
                    next()
                }
            }
        },
        {
            path: 'parcelas',
            name: 'Funcionario_Parcelas',
            component: FuncionarioParcelas,
            beforeEnter: (to, from, next) => {
                if (temAcesso('FUNC-PARCELAS-00')) {
                    next()
                }
            }
        },
        {
            path: 'devedoressemacordo',
            name: 'Funcionario_DevedoresSemAcordo',
            component: FuncionarioDevedoresSemAcordo,
            beforeEnter: (to, from, next) => {
                if (temAcesso('FUNC-DEVEDORES-00')) {
                    next()
                }
            }
        },
        {
            path: 'devedorescomacordo',
            name: 'Funcionario_DevedoresComAcordo',
            component: FuncionarioDevedoresComAcordo,
            beforeEnter: (to, from, next) => {
                if (temAcesso('FUNC-DEVEDORES-00')) {
                    next()
                }
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./src/modulos/funcionarios/FuncionariosRotas.js